import Cookies from "js-cookie"
// import toast from "react-hot-toast"

const apiClient = async (
  endpoint,
  method = "GET",
  body = null,
  headers = {}
) => {
  let token = null
  const tokenData = Cookies.get("auth")
  if (tokenData) {
    const decodedTokenData = JSON.parse(tokenData)
    token = decodedTokenData?.accessToken || ""
  }

  // console.log("-> token:", token)
  // console.log("-> endpoint:", endpoint)

  const options = {
    method,
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      // userName: "shailesh",
      ...headers,
    },
  }

  if (body instanceof FormData) {
    options.body = body // FormData handles its own Content-Type
  } else if (body) {
    options.body = JSON.stringify(body)
    options.headers["Content-Type"] = "application/json" // Only for JSON
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
      options
    )
    const contentType = response.headers.get("content-type")

    if (!response.ok) {
      if (contentType && contentType.includes("application/json")) {
        const error = await response.json()
        throw error?.message
      } else {
        const error = await response.text()
        throw error || `HTTP error! Status: ${error.status}`
      }
    }

    if (contentType.includes("application/json")) {
      return await response.json()
    }

    return response
  } catch (error) {
    if (typeof error === "string") {
      throw error
    } else {
      throw "Oops...! Something went wrong"
    }
  }
}

export const get = (endpoint, headers) =>
  apiClient(endpoint, "GET", null, headers)
export const post = (endpoint, body, headers) =>
  apiClient(endpoint, "POST", body, headers)
export const put = (endpoint, body, headers) =>
  apiClient(endpoint, "PUT", body, headers)
export const remove = (endpoint, body, headers) =>
  apiClient(endpoint, "DELETE", body, headers)
